import { ActorFilterRegistryCategory } from '../ActorFilterRegistryCategory';
import { ActorFilterRegistryItem } from '../ActorFilterRegistryItem';
import { runtime } from '../../../classes/runtime/Runtime';
export class ActorFilterKnowAWord extends ActorFilterRegistryCategory {
    label = 'KnowAWord';
    constructor(parent) {
        super(parent);
        super.init();
    }
    prefix_text = () => new ActorFilterRegistryItem({
        label: 'Prefix > Text',
        filter: ({ a }) => a instanceof runtime.class.AttachedText && a.aspect.name === 'prefix'
    });
    postfix_text = () => new ActorFilterRegistryItem({
        label: 'Postfix > Text',
        filter: ({ a }) => a instanceof runtime.class.AttachedText && a.aspect.name === 'postfix'
    });
}
